import { TypedEmitter } from 'tiny-typed-emitter'

interface PeerMidiActivityEvents {
    mididata: (deviceId: string, data: number[]) => void
}

class PeerMidiActivityEventEmitterClass extends TypedEmitter<PeerMidiActivityEvents> {
    write(deviceId: string, data: number[]) {
        this.emit('mididata', deviceId, data)
    }
}

export const PeerMidiActivityEventEmitter = new PeerMidiActivityEventEmitterClass()
